var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-list-item",domProps:{"innerHTML":_vm._s(_vm.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }